import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-on-surface font-body pb-20" dir="rtl">
      {/* ── Header ── */}
      <header className="sticky top-0 z-50 bg-[#f9f9f9]/80 backdrop-blur-md px-6 py-4 flex items-center gap-4">
        <button 
          onClick={() => navigate(-1)} 
          className="p-2 rounded-full hover:bg-surface-container transition-colors active:scale-95"
        >
          <span className="material-symbols-outlined text-primary">arrow_forward</span>
        </button>
        <h1 className="font-headline font-bold text-xl text-primary">תנאי שימוש</h1>
      </header>

      <main className="max-w-2xl mx-auto px-6 pt-8">
        <div className="bg-surface-container-lowest rounded-2xl p-8 recipe-card-shadow border border-outline-variant/10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
              <span className="material-symbols-outlined text-primary text-2xl">gavel</span>
            </div>
            <div>
              <h2 className="text-2xl font-headline font-extrabold text-on-surface leading-tight">כללי השימוש בשירות</h2>
            </div>
          </div>

          <div className="space-y-8 text-on-surface-variant leading-relaxed text-base">
            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                1. שירות מבוסס AI
              </h3>
              <p>המתכונים באפליקציה מופקים באמצעות בינה מלאכותית (AI). ייתכנו טעויות במידע, בכמויות, ברכיבים או בהוראות ההכנה. עליך לבדוק את המתכון ולהפעיל שיקול דעת לפני תחילת הבישול והשימוש במידע.</p>
            </section>

            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                2. אחריות
              </h3>
              <p>השימוש במתכונים ובאפליקציה הוא באחריות המשתמש בלבד. המפתחים לא יישאו באחריות לכל נזק, פציעה, אלרגיה או אובדן שיגרמו כתוצאה משימוש במידע המופיע באפליקציה או יישומו במציאות.</p>
            </section>

            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                3. זכויות יוצרים
              </h3>
              <p>CookWithAI אינה בעלת הזכויות על סרטוני המקור. זכויות היוצרים על התוכן הויזואלי והקולי שייכות ליוצרי הסרטונים המקוריים בפלטפורמות השונות. האפליקציה משמשת ככלי טכנולוגי לארגון וניתוח מידע ציבורי נגיש.</p>
            </section>

            <section>
              <h3 className="text-lg font-headline font-bold text-on-surface mb-3 flex items-center gap-2">
                <span className="w-1.5 h-6 bg-primary rounded-full" />
                4. שינויים בשירות
              </h3>
              <p>אנו שומרים לעצמנו את הזכות לשנות, להפסיק או לגבות תשלום על חלק מהשירותים בעתיד. כל שינוי משמעותי ילווה בעדכון עבור המשתמשים דרך האתר או האפליקציה.</p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-outline-variant/20 text-center">
            <p className="text-sm text-on-surface-variant font-medium">
              המשך השימוש באפליקציה מהווה הסכמה לתנאים אלו.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
